import { c as _c } from "react/compiler-runtime";
import { KeyboardEventHandler, MouseEventHandler, MutableRefObject, useCallback, useState } from 'react';
import { Key } from 'record-it-utils/utils/Key/Key';
import { useOnOutsideClick } from '../../hooks/useOnOutsideClick';
export function useSelectDropdownVisible(t0) {
  const $ = _c(9);
  const {
    inputElementRef,
    dropdownElementRef
  } = t0;
  const [dropdownVisible, setDropdownVisible] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setDropdownVisible(true);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleInputClick = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = event => {
      if (event.key === Key.ArrowDown || event.key === Key.ArrowUp) {
        setDropdownVisible(true);
      } else {
        if (event.key === Key.Tab) {
          setDropdownVisible(false);
        }
      }
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleInputKeydown = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setDropdownVisible(false);
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const handleOptionSelected = t3;
  let t4;
  if ($[3] !== dropdownElementRef || $[4] !== inputElementRef) {
    t4 = [inputElementRef, dropdownElementRef];
    $[3] = dropdownElementRef;
    $[4] = inputElementRef;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      setDropdownVisible(false);
    };
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  useOnOutsideClick(t4, t5);
  let t6;
  if ($[7] !== dropdownVisible) {
    t6 = {
      dropdownVisible,
      handleInputClick,
      handleInputKeydown,
      handleOptionSelected
    };
    $[7] = dropdownVisible;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
}
export type UseSelectDropdownVisibleOptions = {
  inputElementRef: MutableRefObject<HTMLElement | null>;
  dropdownElementRef: MutableRefObject<HTMLElement | null>;
};
export type UseSelectDropdownVisibleReturnValue = {
  dropdownVisible: boolean;
  handleInputClick: MouseEventHandler;
  handleInputKeydown: KeyboardEventHandler;
  handleOptionSelected: () => void;
};